export default __webpack_public_path__ + "d3434999dd3b35cb466b78c669dcf754.png";